import React, { useEffect, useState } from "react";

export default function PromoBar({ promo, testid = "promo-bar" }) {
  const [nowTs, setNowTs] = useState(Date.now());

  useEffect(() => {
    if (!promo || !promo.countdown || !promo.end) return;
    const t = setInterval(() => setNowTs(Date.now()), 1000);
    return () => clearInterval(t);
  }, [promo]);

  if (!promo || !promo.enabled || !promo.text) return null;
  const now = Date.now();
  const okStart = !promo.start || new Date(promo.start).getTime() <= now;
  const okEnd = !promo.end || new Date(promo.end + "T23:59:59").getTime() >= now;
  if (!okStart || !okEnd) return null;

  let countdown = "";
  if (promo.countdown && promo.end) {
    const diff = new Date(promo.end + "T23:59:59").getTime() - nowTs;
    if (diff > 0) {
      const d = Math.floor(diff / 86400000), h = Math.floor((diff % 86400000) / 3600000),
        m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
      countdown = ` · Termina en ${d}d ${h}h ${m}m ${s}s`;
    }
  }

  return (
    <a href={promo.link || undefined} style={promo.bg ? { backgroundColor: promo.bg } : undefined}
      className="block bg-brand text-white text-center text-xs sm:text-sm font-medium py-2 px-4 hover:opacity-90 transition-opacity" data-testid={testid}>
      {promo.text}{countdown}
    </a>
  );
}
